import { cn } from '@/lib/utils'
import { splitFormattedCurrency } from '@/lib/format-number'

interface PlayerStatCardProps {
	label: string
	value: string
	tone: 'amber' | 'green'
}

const TONE_CLASSES = {
	amber: {
		border: 'border-warning/40',
		glow: 'bg-[radial-gradient(ellipse_at_50%_120%,hsl(var(--warning)/0.35),transparent_70%)]',
	},
	green: {
		border: 'border-primary/40',
		glow: 'bg-[radial-gradient(ellipse_at_50%_120%,hsl(var(--primary)/0.35),transparent_70%)]',
	},
} as const

export function PlayerStatCard({ label, value, tone }: PlayerStatCardProps) {
	const { main, decimals } = splitFormattedCurrency(value)
	const toneClasses = TONE_CLASSES[tone]

	return (
		<div className={cn('relative flex flex-1 flex-col items-center justify-center overflow-hidden rounded-xl border bg-secondary px-4 py-5', toneClasses.border)}>
			<div className={cn('pointer-events-none absolute inset-0', toneClasses.glow)} aria-hidden />
			<span className='relative text-sm font-medium tracking-[-0.21px] text-muted-foreground'>{label}</span>
			<div className='relative mt-2 text-center tracking-[-0.24px]'>
				{tone === 'green' ? (
					<>
						<span className='text-2xl font-semibold text-foreground'>$ {main}</span>
						{decimals && <span className='text-base font-semibold text-muted-foreground'>{decimals}</span>}
					</>
				) : (
					<span className='text-2xl font-semibold text-foreground'>{value}</span>
				)}
			</div>
		</div>
	)
}
